import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";

const ViewSupplyChainLoading = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [permission, setPermission] = useState({});


  useEffect(() => {
    setPermission(FindModuleById(111));
    console.log(permission);

    axios
      .get(`/supply-chain-loading/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log(response);

        if (response.data.code === 200) {
          setValue(response.data.data.supply_chain_loading);
          console.log(response.data.data.supply_chain_loading);
          axios.get(`/helper/currency-by-order/${response.data.data.supply_chain_loading.order_id}`, {
            headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
          })
            .then((response) => {
              if (response.data.code === 200) {
                // console.log(response.data.data);
                setCurrencySymbol(response.data.data.customer_currency)

              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  console.log(value);

  const viewFile = (link) => {
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
      accessKeyId: AWS_ACCESS_KEY_ID,
      secretAccessKey: AWS_SECRET_ACCESS_KEY,
      region: AWS_DEFAULT_REGION,
      signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = { Bucket: AWS_BUCKET, Key: link };
    return s3.getSignedUrl('getObject', params);
  }

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Supply Chain Loading</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/supplychain-loadings">
                        Supply Chain Loading
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Supply Chain Loading
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                {permission && permission.list === 1 && (
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Supply Chain Loading Details</h4>
                      <table className="table table-bordered">
                        <tr>
                          <th className="p-3">Date</th>
                          <td className="p-3">
                            {value.date_of_loading}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Invoice Number</th>
                          <td className="p-3">
                            {value.invoice_number}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Customer</th>
                          <td className="p-3">
                            {value.company_name}
                          </td>
                        </tr>


                        <tr>
                          <th className="p-3">Container Number</th>
                          <td className="p-3">
                            {value.container_number}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Transport Cost</th>
                          <td className="p-3">{value.transport_cost}{currencySymbol}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Loading Status</th>
                          <td className="p-3">{value.loading_status_id ? value.location_status.title : ""}</td>
                        </tr>


                        <tr>
                          <th className="p-3">Product</th>
                          <td className="p-3">
                            {value.product_name}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">PO Order</th>
                          <td className="p-3">
                            {value.order_names}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Contract Number</th>
                          <td className="p-3">
                            {value.contract_number}
                          </td>
                        </tr>

                        <tr>
                          <th className="p-3">ETA Date</th>
                          <td className="p-3">
                            {value.eta_date}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Location</th>
                          <td className="p-3">
                            {value.locationname}
                          </td>
                        </tr>


                        <tr>
                          <th className="p-3">Transit  Supplier</th>
                          <td className="p-3">
                            {value.transitsupplier ? value.transitsupplier.name : ""}
                          </td>
                        </tr>

                        <tr>
                          <th className="p-3">Truck Number</th>
                          <td className="p-3">{value.truck_number_show}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Weight</th>
                          <td className="p-3">{value.total_net_weight}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Invocie Amount</th>
                          <td className="p-3">{value.total_amount}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Packaging</th>
                          <td className="p-3">{value.total_boxes}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Arrival Date</th>
                          <td className="p-3">{value.arrival_date}</td>
                        </tr>


                        <tr>
                          <th className="p-3">Sous Dum</th>
                          <td className="p-3">{value.sous_dum}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Temp Tale</th>
                          <td className="p-3">
                            {value.temp_tale && (value.temp_tale.startsWith('http://') || value.temp_tale.startsWith('https://')) ? (
                              <a className="btn btn-link" target="_bank" href={value.temp_tale}>{value.temp_tale}</a>
                            ) : (
                              <span>{value.temp_tale}</span>
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th className="p-3">Value In MAD</th>
                          <td className="p-3">{value.value_in_mad}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Exchange Rate</th>
                          <td className="p-3">{value.exchange_rate}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Dum</th>
                          <td className="p-3">{value.dum}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Facture Trans</th>
                          <td className="p-3">{value.facture_trans}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Facture Transitaire</th>
                          <td className="p-3">{value.facture_Transitaire}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Num Expédition DHL</th>
                          <td className="p-3">{value.num_expedition_dhl}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Facture DHL</th>
                          <td className="p-3">{value.facture_dhl}</td>
                        </tr>

                        <tr>
                          <th className="p-3">T1 and Phyto</th>
                          <td className="p-3">{value.t1_and_phyto}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Numero du Chauffeur</th>
                          <td className="p-3">{value.numero_du_chauffeur}</td>
                        </tr>

                      </table>
                      <br />
                      <h5 className="card-title">Supply Chain Loading Files</h5>

                      <table className="table table-bordered">
                        <tr>
                          <th className="p-3">File Name</th>
                          <th className="p-3">File Type</th>
                          <th className="p-3">File Link</th>
                          <th className="p-3">File Extension</th>
                        </tr>
                        {value.loading_files &&
                          value.loading_files.map((item, index) => (
                            <tr key={item.file_name || index}>
                              <td className="p-3">{item.file_name}</td>
                              <td className="p-3">{item.file_type_name}</td>
                              <td className="p-3">
                                {item.link && (
                                  <a
                                    className="btn btn-link"
                                    href={viewFile(item.link)}
                                    target="_blank"
                                    rel="noreferrer"
                                    download
                                  >
                                    Download
                                  </a>
                                )}

                              </td>
                              <td className="p-3">{item.extension}</td>
                            </tr>
                          ))}
                      </table>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewSupplyChainLoading;
